import { AddBeneficiary, ManageBeneficiaries, ModalParts } from 'BreetComponents';
import { useFiatWithdrawRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

import FormComponent from './components/FormComponent';
import TransactionDetails from './components/TransactionDetails';

const FiatWithdrawRequest = () => {
	const { formStage, beneficiaries } = useFiatWithdrawRequestContext();

	const onAddBeneficiarySuccess = useCallback(() => {
		formStage.navigator.reset();
		formStage.navigator.goTo('withdraw-funds')();
	}, [formStage.navigator]);

	return (
		<>
			<ModalParts.Stage hide={!formStage.isStageActive('withdraw-funds')}>
				<FormComponent />
			</ModalParts.Stage>

			<ModalParts.Stage hide={!formStage.isStageActive('withdraw-details')}>
				<TransactionDetails />
			</ModalParts.Stage>

			<ModalParts.Stage hide={!formStage.isStageActive('add-beneficiary')}>
				<AddBeneficiary
					intent='initiate a withdrawal'
					noBeneficiary={!beneficiaries.length}
					onSuccess={onAddBeneficiarySuccess}
				/>
			</ModalParts.Stage>

			<ModalParts.Stage hide={!formStage.isStageActive('manage-beneficiaries')}>
				<ManageBeneficiaries onAddNewBeneficiary={formStage.navigator.goTo('add-beneficiary')} />
			</ModalParts.Stage>
		</>
	);
};

export default FiatWithdrawRequest;
